



































































import { Component, Vue, Prop, Watch } from "@/shared/vuepack";
import VueRouter, { Location } from "vue-router";
import _ from "lodash";
import moment from "moment";
import FileUpload from "vue-upload-component";
import { AccountCancelUploadStatus } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { useInvestmentAccountCloseStore } from "@/admin/store/InvestmentAccountClose";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner,
    Pagination
  }
})

export default class InvestmentAccountClose extends Vue {
  $router: VueRouter;
  AccountCancelUploadStatus = AccountCancelUploadStatus;
  file = null;
  isSubmitting = false;
  investmentAccountCloseStore = useInvestmentAccountCloseStore();
  notifierStore = useNotifierStore();

  @Prop()
  page: number;

  @Prop()
  routeToAccountCloseManagement: (page: number) => Location;

  mounted (): void {
    this.load();
  }

  load (): void {
    this.investmentAccountCloseStore.getUploads({page: this.page});
  }

  get uploadItems () {
    const uploads = this.investmentAccountCloseStore.pagedUploadsById(this.page);

    if (uploads) {
      return uploads.map(d => ({
        fileName: d.fileName,
        dateUploaded: moment(d.dateUploaded).format("MMMM D, YYYY"),
        uploadStatus: d.uploadStatus,
        download: d.drivewealthAccountCancelUploadId,
        numberOfRecords: d.numberOfRecords,
        completedCount: d.completedCount,
        failedCount: d.failedCount
      }));
    }

    return uploads;
  }

  get submitDisabled (): boolean {
    return this.isSubmitting || this.investmentAccountCloseStore.isUploadingAccountCloseFile;
  }

  get pageTotal (): number {
    return this.investmentAccountCloseStore.pageTotal(this.page);
  }

  get pageLoaded (): boolean {
    return this.investmentAccountCloseStore.isPageLoaded(this.page);
  }

  fileChange (file): void {
    if (!file) return;
    this.file = (document.getElementById("file-asset") as any).files[0];
  }

  get fileNameDisplay (): string {
    return this.file ? this.file.name : "Click to select .csv file";
  }

  downloadResultsFileCsv (event, drivewealthAccountCancelUploadId: number): void {
    event.preventDefault();
    this.investmentAccountCloseStore.downloadResultsFileCsv({ drivewealthAccountCancelUploadId });
  }

  submit (): void {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.investmentAccountCloseStore.uploadAccountCloseFile ({
      file: this.file
    })
        .catch(() => null)
        .finally(() => {
          this.isSubmitting = false;
          this.file = null;
        });
  }

  onPageChanged (pageNumber: number): void {
    this.$router.push(this.routeToAccountCloseManagement(pageNumber));
  }

  @Watch("page")
    onRouteValuePageNumberChanged () {
      this.load();
    }
}
